var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { EnhancedError, EnhancedAuthNError, EnhancedAuthZError, badResponseError, } from "../api/errors";
function isApigeeFetchError(errorObject) {
    const apigeeKeys = ["id", "code", "title", "detail"];
    return apigeeKeys.every((key) => key in errorObject);
}
function toEnhancedError(errorObject, ErrorConstructor = EnhancedError) {
    if (isApigeeFetchError(errorObject)) {
        const { id: errorCode, detail: errorDescription } = errorObject;
        return new ErrorConstructor(errorCode, {
            errorCode,
            errorDescription,
        });
    }
    return new ErrorConstructor(errorObject.errorCode, errorObject);
}
/**
 * If response content length is not 0 and the status is not 204, return valid
 *
 * @param response Response type
 * @returns Boolean of response status
 *
 * @remarks
 * a status of 204 is No Content, so there will be no payload to return
 * (response.json() would fail) Also, keepAlive may return a 200 with
 * content-length of 0. If .json() is called on this response, an error will
 * be thrown.
 */
export const isResponseContentValid = (response) => {
    const contentLength = response.headers.get("Content-Length");
    return response.status !== 204 && contentLength !== "0";
};
/**
 * Does the payload only contain errors
 *
 * @param payload FetchErrorPayload
 * @returns Boolean payload length
 */
export const isPayloadOnlyErrors = (payload) => {
    // guards against the server returning a null payload for a 200 response
    const errors = (payload === null || payload === void 0 ? void 0 : payload.errors) || [];
    return !!errors.length && Object.keys(payload).length === 1;
};
export const checkForErrorsObject = (response) => __awaiter(void 0, void 0, void 0, function* () {
    var _a, _b;
    try {
        const payload = yield ((_a = response.json) === null || _a === void 0 ? void 0 : _a.call(response));
        const errorObject = (_b = payload === null || payload === void 0 ? void 0 : payload.errors) === null || _b === void 0 ? void 0 : _b[0];
        if (response.status === 401) {
            throw toEnhancedError(errorObject !== null && errorObject !== void 0 ? errorObject : {
                errorCode: "401",
                errorDescription: "Authentication Failure",
            }, EnhancedAuthNError);
        }
        if (response.status === 403) {
            throw toEnhancedError(errorObject !== null && errorObject !== void 0 ? errorObject : {
                errorCode: "403",
                errorDescription: "Authorization Failure",
            }, EnhancedAuthZError);
        }
        if (!errorObject)
            throw badResponseError;
        throw toEnhancedError(errorObject);
    }
    catch (e) {
        if (e === null || e === void 0 ? void 0 : e.errorCode)
            throw e;
        else
            throw badResponseError;
    }
});
export const handleResponse = (response) => __awaiter(void 0, void 0, void 0, function* () {
    if (!response.ok) {
        return checkForErrorsObject(response);
    }
    if (!isResponseContentValid(response)) {
        throw badResponseError;
    }
    const payload = yield response.json();
    if (payload == null)
        throw badResponseError;
    if (isPayloadOnlyErrors(payload)) {
        const errorObject = payload.errors[0];
        throw toEnhancedError(errorObject);
    }
    return payload;
});
//# sourceMappingURL=handleResponse.js.map